import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { User, UserChangePassword } from '../models/user';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  controller = 'user';

  constructor(private base: BaseService) { }

  get(id): Observable<ApiObjectData> {
    return this.base.get(id, this.controller);
  }

  getCurrant(): Observable<ApiObjectData> {
    return this.base.gets(this.controller + '/GetCurrant');
  }

  userData(id): Observable<ApiObjectData> {
    return this.base.get(id, this.controller + '/UserData');
  }

  gets(): Observable<ApiObjectData> {
    return this.base.gets(this.controller);
  }

  checkUserNameExist(userName:string){
    return this.base.gets(this.controller+'/CheckUserNameExist/'+userName)
  }

  getUserByUserName(username: string) {
    return this.base.gets(this.controller + '/GetUserByUserName/' + username)
  }

  GetNotificationById() {
    return this.base.gets(this.controller + '/GetNotificationByUserId' )
  }

  ChangePassword(obj: UserChangePassword) {
    return this.base.save(this.controller + '/ChangePassword', obj);
  }

  
  resetPassword(obj: User) {
    return this.base.save(this.controller + '/ResetPassword', obj);
  }

  save(obj: User) {
    return this.base.save(this.controller, obj);
  }

  remove(id: number) {
    return this.base.remove(this.controller, id);
  }
}
